<template>
    <div class="navigation" :class="{ 'navigation--flex' : isMAPage }">
        <div v-if="isMAPage" class="navigation__left">
            <div class="navigation__logo">
                <img class="list-info-item__summary__infoimage" :src="`${publicPath}/images/logos/oeamtc.svg`" alt="E-control">
            </div>
            <div class="navigation__slogan">
                Gelbe Engel Routenplaner
            </div>
        </div>
        <div v-if="isMAPage" class="navigation__right">
            <div v-if="user" class="navigation__profile-name h3-bold">
                {{ user.sub }}
            </div>
            <Icon :size="32" class="navigation__profile-icon" :class="{ 'navigation__profile-icon--highlighted' : user }">
                <IconProfile />
            </Icon>
        </div>
        <div v-else v-html="html"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as api from '@/api';
import eventBus from '@/utils/event-bus';

import Icon from '@/components/Icon.vue'
import IconProfile from '@/components/icons/IconProfile.vue'

export default {
    components: {
        Icon,
        IconProfile
    },
    data() {
        return {
            html: '',
            publicPath: process.env.BASE_URL,
        }
    },
    created() {
        if(!this.isMAPage) {
            this.loadExternalHeader()
            this.addListeners()
        }
    },
    beforeDestroy() {
        this.removeListeners()
    },
    computed: {
        ...mapGetters(['openPOIAfterLogin', 'isMAPage', 'user'])
    },
    watch: {
        user(newVal, oldVal) {
            console.log('change user value and this new value is:' , newVal , ' and old value is ' , oldVal)
        }
    },
    methods: {
        async loadExternalHeader() {
            try {
                const htmlResponse = await api.static.oeamtcHeaderHTML()
                const cssResponse = await api.static.oeamtcHeaderCSS()
                const jsResponse = await api.static.oeamtcHeaderJS()
                const trackingResponse = await api.static.oeamtcHeaderTracking()
                this.html = htmlResponse.data
                document.head.insertAdjacentHTML( 'beforeend', cssResponse.data )
                
                const trackingHtml = this.parseHTML(trackingResponse.data)
                const trackingScriptEls = trackingHtml.querySelectorAll('script')
                trackingScriptEls.forEach(scriptEl => {
                    let newScriptEl = document.createElement('script');
                    const scriptElAttributes = scriptEl.attributes
                    if(scriptElAttributes) {
                        [...scriptElAttributes].forEach(attribute => {
                            newScriptEl.setAttribute(attribute.nodeName, attribute.nodeValue)
                        })
                    }
                    const scriptText = document.createTextNode(scriptEl.innerHTML);
                    newScriptEl.appendChild(scriptText);
                    document.head.appendChild(newScriptEl);
                })

                const scriptsHtml = this.parseHTML(jsResponse.data);
                const scriptEls = scriptsHtml.querySelectorAll('script');
                // only wait for oeamtc scripts to load since the others might be blocked by 3rd party tools
                const oeamtcScriptCount = [...scriptEls].filter(script => { return script.getAttribute('src').includes('oeamtc.at') }).length
                let scriptLoadedIndex = 0;
                scriptEls.forEach(scriptEl => {
                    let newScriptEl = document.createElement('script');
                    const scriptElAttributes = scriptEl.attributes
                    if(scriptElAttributes) {
                        [...scriptElAttributes].forEach(attribute => {
                            newScriptEl.setAttribute(attribute.nodeName, attribute.nodeValue)
                        })
                    }
                    if(newScriptEl.getAttribute('src').includes('oeamtc.at')) {
                        newScriptEl.addEventListener('load', () => {
                                scriptLoadedIndex++; 
                                if(scriptLoadedIndex === oeamtcScriptCount) {
                                    if(window.cms) {
                                        window.cms.headerReady()
                                        window.cms.identity.registerLoggedInCallback(this.userLoggedInHandler)
                                        window.cms.identity.registerLoggedOutCallback(this.userLoggedOutHandler)
                                        window.cms.identity.registerSessionLoadedCallback(this.userLoggedInHandler)
                                    }
                                }
                        })
                    }
                    document.head.appendChild(newScriptEl);
                })
            } catch(error) {
                console.error(error)
            }
        },
        userLoggedInHandler(data) {
            if(data && data.sessionId) {
                this.$store.dispatch('getUserBySessionId', data.sessionId)
                this.$store.dispatch('getUserSession', data.sessionId)
            }
            if(this.openPOIAfterLogin) {
                this.$store.commit('setCustomActivePoiType', this.openPOIAfterLogin.type);
                this.$store.commit('setActivePoiId', this.openPOIAfterLogin.id);
                this.$store.commit('setCustomActivePoiSubType', this.openPOIAfterLogin.subType);
                this.$store.commit('setOpenPOIAfterLogin', false)
            }
        },
        userLoggedOutHandler() {
            this.$store.commit('setUser', false)
            this.$store.dispatch('getUserSession', false)
        },
        showLoginMenuHandler() {
            const menuTriggerElement = document.querySelector('#small-header-userstate')
            if(menuTriggerElement) {
                setTimeout(() => {
                    menuTriggerElement.click()
                }, 10);
            }
        },
        addListeners() {
            eventBus.$on('showLoginMenu', this.showLoginMenuHandler)  
        },
        removeListeners() {
            eventBus.$off('showLoginMenu', this.showLoginMenuHandler)  
        },
        parseHTML(html) {
            var t = document.createElement('template');
            t.innerHTML = html;
            return t.content.cloneNode(true);
        }
    }
}
</script>

<style lang="scss">
.navigation {
    height: $nav-height;
    background-color: $color-yellow;

    &--flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 14px;
    }

    .oeamtc-page-header--small {
        max-width: none !important;

        .small-header-inline-navigation,
        .small-header-search-icon {
            display: none;
        }

        .small-header-userstate {
            right: 50px;
        }
    }

    &__left,
    &__right {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    &__logo {
        height: 26px;
        border-right: 2px solid $color-black;
        padding-right: 16px;

        @include mq($until: mobile-landscape) {
            border: none;
            padding: 0;
        }

        @include mq(tablet) {
            height: 35px;
        }

        img {
            height: 100%;
        }
    }

    &__slogan {
        font-size: 16px;

        @include mq(tablet) {
            font-size: 18px;
        }

        @include mq($until: mobile-landscape) {
            display: none;
        }
    }

    &__profile-name {
        @include mq($until: tablet) {
            display: none;
        }
    }

    &__profile-icon {
        &--highlighted {
            color: $color-blue;
        }
    }
}
</style>